export default __webpack_public_path__ + "static/media/gf.9a161650.jpg";